<template>
  <div class="living-item">
    <div
      class="cover-pic"
      :style="{ backgroundImage: `url(${item.pictureUrl})` }"
    >
      <div
        :class="[
          'tag',
          item.playStatus == 2 && 'tag-replay',
          item.playStatus == 1 && 'tag-living',
        ]"
      >
        {{
          item.playStatus == 3
            ? "预告"
            : item.playStatus == 2
            ? "回放"
            : "直播中"
        }}
      </div>
    </div>
    <div class="title text-line-2">
      {{ item.name }}
    </div>
    <div class="info">开播时间：{{ item.startDate }}</div>
  </div>
</template>

<script>
export default {
  name: "LivingItem",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.living-item {
  box-sizing: border-box;
  padding: 0 10px;
  width: 100%;

  .cover-pic {
    position: relative;
    width: 100%;
    height: 200px;
    border-radius: 8px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 3px 8px;
      border-radius: 0 10px;
      background: linear-gradient(
        136deg,
        #8583e7 0%,
        #7ea9f9 48%,
        #91e0ff 100%
      );
      color: #fff;
    }

    .tag-replay {
      background: rgba(0, 0, 0, 0.65);
    }

    .tag-living {
      background: linear-gradient(139deg, #f75a90 1%, #e92c13 100%);
    }
  }

  .title {
    font-size: 16px;
    color: #000000d9;
    margin: 10px 0;
  }

  .info {
    font-size: 12px;
    color: #00000073;
    margin-bottom: 20px;
  }
}
</style>